<div class="flex h-fit flex-col justify-center">
  <div class="mx-auto flex-1">
    <div class="flex justify-center gap-2">
      <app-strategies-info [campaignType]="CampaignType.SP" [strategies]="data.linkedStrategies"></app-strategies-info>
      <app-strategies-info [campaignType]="CampaignType.SB" [strategies]="data.linkedStrategies"></app-strategies-info>
      <app-strategies-info [campaignType]="CampaignType.SD" [strategies]="data.linkedStrategies"></app-strategies-info>
    </div>
  </div>
</div>
